import { KeybindingsRegistry } from 'vscode/vscode/vs/platform/keybinding/common/keybindingsRegistry';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import './terminalProfileResolverService.js';
import { TerminalContextKeys } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminalContextKey';

KeybindingsRegistry.registerKeybindingRule({
    id: "workbench.action.terminal.new" ,
    weight: 200 ,
    when: TerminalContextKeys.notFocus,
    primary: 2048  | 1024  | 33
});
